import { render, staticRenderFns } from "./margin-rate-popover.vue?vue&type=template&id=13804cca&"
import script from "./margin-rate-popover.vue?vue&type=script&lang=js&"
export * from "./margin-rate-popover.vue?vue&type=script&lang=js&"
import style0 from "./margin-rate-popover.vue?vue&type=style&index=0&id=13804cca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports